var React = require('react');

function Bulb (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M55.4,24.6C55.4,11.7,44.9,1.3,32,1.3C19.1,1.3,8.6,11.7,8.6,24.6c0,9.3,5.4,17.3,13.2,21v12.2c0,2.7,2.2,4.8,4.8,4.8h11.1\tc2.7,0,4.8-2.2,4.8-4.8V45.4C50.2,41.5,55.4,33.7,55.4,24.6z M39.1,47.2v10.7c0,0.7-0.6,1.3-1.3,1.3H26.7c-0.7,0-1.3-0.6-1.3-1.3\tV47.2H26c1.9,0.5,3.9,0.8,6,0.8c2.1,0,4.1-0.3,6-0.8H39.1z M33.7,44.4V32v-0.2l6.1-4.7c0.8-0.6,0.9-1.7,0.3-2.5\tc-0.6-0.8-1.7-0.9-2.5-0.3l-4,3v-6c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8v6.2l-4.7-3.3c-0.8-0.6-1.9-0.4-2.4,0.4\tc-0.6,0.8-0.4,1.9,0.4,2.4l6.8,4.8v0v12.4C20.1,43.5,12.1,35,12.1,24.6c0-11,8.9-19.9,19.9-19.9s19.9,8.9,19.9,19.9\tC51.9,35,43.9,43.5,33.7,44.4z"}));
}

Bulb.defaultProps = {"version":"1.1","viewBox":"0 0 64 64","x":"0","y":"0","xmlSpace":"preserve"};

module.exports = Bulb;

Bulb.default = Bulb;
